import * as process from 'process';
import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import ReactGA from 'react-ga';
import { Route, Routes, useLocation } from 'react-router-dom';
import AppMenu from './components/AppMenu';
import { Root, classes } from './components/Root';
import { Configuration } from './Configuration';
// import UserStateProvider from './context/UserStateContext';
import { FileUploadProvider } from './context/FileUploadContext';
import ComingSoonPage from './pages/ComingSoonPage';
import { allRoutes } from './routes';

// Only assign process to window in browser environment, not in tests
if (typeof window !== 'undefined' && typeof window['process'] === 'undefined') {
    window['process'] = process;
}

const App: React.FC = () => {

    const [cookies] = useCookies();

    const [analyticsEnabled, setAnalyticsEnabled] = useState<boolean>(false);
    const location = useLocation();

    useEffect(() => {
        const cookieConsent = cookies['cookieConsent'] as string ?? 'false';
        setAnalyticsEnabled(cookieConsent.toLowerCase() === 'true');
    }, [cookies])



    useEffect(() => {
        if (analyticsEnabled) {
            ReactGA.initialize('UA-182717-7');
        }
    }, [analyticsEnabled]);

    useEffect(() => {
        if (analyticsEnabled) {
            const page = window.location.pathname + window.location.search;
            if (!window.location.href.includes("localhost")) {
                ReactGA.pageview(page);
            }
        }

    }, [analyticsEnabled, location])

    return (
        <>
            {
                (Configuration.isFeatureEnabled('comingSoonPage') && location.pathname === '/')
                    ? <Root><ComingSoonPage /></Root>
                    : <>
                        <FileUploadProvider>
                            <AppMenu />
                            <Root className={classes.container}>
                                <Routes>
                                    {allRoutes.map((route, index) => (
                                        <Route key={index} path={route.path} element={route.element} />
                                    ))}
                                </Routes>
                            </Root>
                        </FileUploadProvider>
                    </>
            }
        </>
    )
}
export default App;
